Office.onReady(() => {
  // If needed, Office.js is ready to be called.
});

/**
 * Closes the taskpane when command is executed.
 * @param event
 */
function closeTaskpane(event: Office.AddinCommands.Event) {
  Office.addin.hide();
  event.completed();
}

// Register the function with Office.
Office.actions.associate("closeTaskpane", closeTaskpane);
